"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.download = void 0;
exports.download = {
    path: "M15.8334 7.91667H12.5V2.91667H7.50002V7.91667H4.16669L10 13.75L15.8334 7.91667ZM9.16669 9.58334V4.58334H10.8334V9.58334H11.8084L10 11.3917L8.19169 9.58334H9.16669ZM15.8334 17.0833V15.4167H4.16669V17.0833H15.8334Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2"
};
